import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { setCommissionHistory } from '@api/commissionSettings';

import { TCommissionHistoryRecountDTO } from '@interfaces/organisation/dto/organisationsDTO';

import { ESnackbarTypes } from '@enums/common';

import {
	COMMISSION_HISTORY,
	UPDATE_COMMISSION_SETTINGS,
} from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateCommissionSettingsRecalculate = () => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleRecalculateCommissionSettings,
		isLoading: isLoadingRecalculateCommissionSettings,
	} = useMutation<TCommissionHistoryRecountDTO>({
		mutationKey: [UPDATE_COMMISSION_SETTINGS],
		mutationFn: setCommissionHistory,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.updatedCommissionSettings,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([COMMISSION_HISTORY])];
		},
	});

	return {
		handleRecalculateCommissionSettings,
		isLoadingRecalculateCommissionSettings,
	};
};
